/* -----------------------------
    CUSTOM DELEGATE EXTENSION
   ----------------------------- */
HTMLElement.prototype.customDelegate = function customDelegate(
  eventName,
  elementSelector,
  handler
) {
  this.addEventListener(
    eventName,
    (e) => {
      const element = e.target.closest(elementSelector);

      if (element) {
        handler.call(element, e, element);
      }
    },
    false
  );
};

HTMLElement.prototype.removeCustomDelegate = function removeCustomDelegate(
  eventName,
  elementSelector,
  handler
) {
  this.removeEventListener(
    eventName,
    (e) => {
      const element = e.target.closest(elementSelector);

      if (element) {
        handler.call(element, e, element);
      }
    },
    false
  );
};

/* -----------------------------
    DEBOUNCE EXTENSION
   ----------------------------- */
Function.prototype.debounce = function (delay) {
  let timeoutId;
  const func = this;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

/* -----------------------------
    SHOPIFY MONEY FORMATTER
   ----------------------------- */

theme.formatMoney = function (cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || theme.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

/* -----------------------------
    CACHED FETCH
   ----------------------------- */

window.cachedResponses = new Map();

window.cachedFetch = async function (url, immediate = true, delay = 500) {
  if (cachedResponses.has(url)) {
    if (!immediate) {
      await new Promise(resolve => setTimeout(resolve, delay));
    }

    return Promise.resolve(cachedResponses.get(url));
  }

  const networkResponse = await fetch(url);

  if (networkResponse.ok) {
    const contentType = networkResponse.headers.get("content-type");

    if (contentType.includes("application/json")) {
      const responseBody = await networkResponse.json();
      cachedResponses.set(url, responseBody);

      return Promise.resolve(responseBody);
    } else if (contentType.includes("text")) {
      const textResponse = await networkResponse.text();
      cachedResponses.set(url, textResponse);

      return Promise.resolve(textResponse);
    } else {
      const blobResponse = await networkResponse.blob();
      return Promise.resolve(blobResponse);
    }
  }

  return Promise.resolve(networkResponse);
}
